import { appRouterPaths } from 'services/navigation';
import { ScheduleForWeekPage } from 'pages/ScheduleForWeek';
import { ScheduleConfigurationPage } from 'pages/ScheduleConfiguration';
import { EducationPlanSchedulesPage } from 'pages/EducationPlanSchedules';
import { SchedulePage } from 'pages/Schedule';
import type { AppRouteProps } from '../types';

export const scheduleForWeekPageRoute: AppRouteProps = {
  path: appRouterPaths.scheduleForWeek,
  element: <ScheduleForWeekPage />,
};

export const scheduleConfigurationFormPageRoute: AppRouteProps = {
  path: appRouterPaths.scheduleConfigurationForm,
  element: <ScheduleConfigurationPage />,
};

export const configurationSchedulesPageRoute: AppRouteProps = {
  path: appRouterPaths.configurationSchedules,
  element: <EducationPlanSchedulesPage />,
};

export const schedulePageRoute: AppRouteProps = {
  path: appRouterPaths.schedule,
  element: <SchedulePage />,
};
